module.exports = __webpack_public_path__ + "img/logo_s.ad54dec0.png";